module.exports = __webpack_public_path__ + "static/media/hardware1.8be5bf53.png";